export default class AdSkipButton {
  constructor({tech, ima, data} = {}) {
    this._tech = tech;
    this._ima = ima;
    this._data = data;
    this._skipButton = null;
    this._adRemainder = null;
    this._buttonNeedToBeUpdated = false;
  }

  init() {
    this.bindAdStart();
    this.bindAdLoaded();
    this.bindAdComplete();
  }

  bindAdStart() {
    this.tech().on('adstarted', () => {
      this.appendAdRemainder();
    });
  }

  bindAdComplete() {
    this.tech().on('adcomplete', () => {
      if (this.adRemainder()) {
        this.removeAdRemainder();
      }
      if (this.skipButton()) {
        this.removeSkipButton();
      }
    });
  }

  bindAdLoaded() {
    this.tech().on('adloaded', ()=>{
      if (this.adRemainder()) {
        this.removeAdRemainder();
      }
      if (this.skipButton()) {
        this.removeSkipButton();
      }
    });
  }

  removeSkipButton() {
    this.tech().el().removeChild(this._skipButton);
    this._skipButton = null;
    this._buttonNeedToBeUpdated = false;
  }

  removeAdRemainder() {
    this.tech().el().removeChild(this.adRemainder());
    this._adRemainder = null;
  }

  isAcceptableAd() {
    return this.isWhitelistedCreative() || this.isWhitelistedLineItem() || Math.floor(this.ima().currentAdDuration()) <= this.unskippableAdDuration() || this.adIsSkippable();
  }

  isWhitelistedLineItem() {
    const adId = this.currentAd().getAdId();

    if (this.data().whitelistedLineItemIds().includes(adId)) {
      return true;
    }

    const wrapperAdIds = this.currentAd().getWrapperAdIds();
    if (wrapperAdIds.length > 0) {
      const lastIndexWrapperAdId = wrapperAdIds[wrapperAdIds.length - 1];
      if (this.data().whitelistedLineItemIds().includes(lastIndexWrapperAdId)) {
        return true;
      }
    }

    return false;
  }

  isWhitelistedCreative() {
    const creativeId = this.currentAd().getCreativeId();
    return this.data().whitelistedCreativeIds().includes(creativeId) ? true : false;
  }

  appendAdRemainder() {
    if (!this.currentAd()) return;
    if (this.isAcceptableAd()) return;

    this.containerEl().appendChild(this.createAdRemainder());
    this.bindImaAdProgress();
  }
  
  bindImaAdProgress() {
    this._buttonNeedToBeUpdated = true;
    this.ima().addEventListener(google.ima.AdEvent.Type.AD_PROGRESS, (e) => {
      if (this.buttonNeedToBeUpdated()) {
        this.updateSkipAdButton(e.getAdData().currentTime);
      }
    });
  }
 
  createAdRemainder() {
    const remainder = document.createElement('div');
    remainder.className = 'vjs-ad-skip-remaining';
    remainder.innerHTML = this.skipAdOffset().toString();

    this._adRemainder = remainder;
    return remainder;
  }

  updateSkipAdButton(currentTime) {
    this.appendSkipButtonToAdContainer(currentTime);
    this.updateAdRemainder(currentTime);
  }

  appendSkipButtonToAdContainer(currentTime) {
    if (currentTime >= this.skipAdOffset() && !this._skipButton) {
      this.containerEl().appendChild(this.createSkipButton());
    }
  }

  updateAdRemainder(currentTime) {
    if (this.adRemainder()) {
      const counter = Math.ceil(this.skipAdOffset() - currentTime);

      if (counter <= 0) return;
      this.adRemainder().innerHTML = `${ counter }`;
    }
  }

  createSkipButton() {
    const button = document.createElement('button');
    button.className = 'vjs-ad-skip-button';
    button.textContent = 'Skip Ad';
    button.onclick = () => {
      this.onSkipButtonClick();
    }

    this._skipButton = button;
    return button
  }

  storeAdsVolume() {
    this.ima()._adVolume = this.adsManager().getVolume();
  }

  onSkipButtonClick() {
    this.storeAdsVolume();
    this.tech().trigger({
      type: 'adskipped',
      currentTime: this.ima().adCurrentTime(),
    });
    this.ima().adsManager().stop();
  }

  hideAdContainer() {
    this.tech().el().el().querySelector('.ima-ad-container').style.display = 'none';
  }

  tech() {
    return this._tech;
  }

  containerEl() {
    const playerEl = this.tech().el();
    return playerEl.querySelector(".ima-ad-container");
  }

  ima() {
    return this._ima;
  }

  data() {
    return this._data;
  }

  unskippableAdDuration() {
    return this.data().unskippableAdDuration();
  }

  skipButton() {
    return this._skipButton;
  }

  adRemainder() {
    return this._adRemainder;
  }

  getVideoId() {
    return this.data().videoId();
  }

  getAdPodIndex() {
    return this.currentAd().getAdPodInfo().getPodIndex();
  }

  getAdPosition() {
    return this.currentAd().getAdPodInfo().getAdPosition();
  }

  currentAd() {
    return this.ima().currentAd();
  }

  adsManager() {
    return this.ima().adsManager();
  }

  adIsSkippable() {
    return this.currentAd().isSkippable();
  }

  skipAdOffset() {
    return this.data().customSkipAdButtonOffset();
  }

  buttonNeedToBeUpdated() {
    return this._buttonNeedToBeUpdated;
  }
}
